import React from "react";

export default class RadioInput extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        return (
            <div className='form__input-wrapper' role='radiogroup' aria-labelledby={`${this.props.value}-${this.props.formID}`}>
                <div className='label' id={`${this.props.value}-${this.props.formID}`}>
                    {this.props.label}
                </div>
                {this.props.options.map((radio, index) => {
                    return  <div className='radio__wrapper'>
                                <input type='radio' name={this.props.value} value={radio.value} id={`${this.props.value}-${this.props.formID}-${index}`} className='radio__input'/>
                                <label for={`${this.props.value}-${this.props.formID}-${index}`}>{radio.label}</label>
                            </div>
                })}
            </div>
        )
    }
}